import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Streak from "./Streak";
import TasksCompleted from "./TasksCompleted";
import LeftSidebar from "../../components/LeftSideBar";
import TopicsCompleted from "./TopicsCompleted";
import TasksOverTime from "./TasksOverTime";
import PaiTasks from "./PaiTasks";
import "./Progress.css";
import fetchProtectedData from "../auth/ProtectDataHeader";
import withTokenRefresh from "../auth/RefreshToken";
import PaymentModal from "../payment/PaymentModal";
import SubscribeInfoModal from "../payment/SubscribeInfoModal";

function Progress() {
  const [progressData, setProgressData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const [user_id, setUserId] = useState(null);
  const [API_ENDPOINT, setApiEndpoint] = useState(null);

  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [showInfoModal, setShowInfoModal] = useState(false);

  const openPaymentModal = () => setShowPaymentModal(true);
  const closePaymentModal = () => setShowPaymentModal(false);

  const openInfoModal = (text) => {
    if (text) {
      setInfoText(text);
    } else {
      setInfoText("");
    }
    setShowInfoModal(true);
  };
  const [infoText, setInfoText] = useState("");

  const closeInfoModal = () => setShowInfoModal(false);

  const [subscriptionType, setSubscriptionType] = useState(null);
  const [subscriptionEndDate, setSubscriptionEndDate] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const protectedData = await withTokenRefresh(fetchProtectedData);

        if (!protectedData) {
          navigate("/login");
          return;
        }
        setUserId(protectedData);

        const SUB_ENDPOINT = `/api/subscription/?user_id=${protectedData}`;
        const subscriptionResponse = await fetch(SUB_ENDPOINT, {
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        });

        if (!subscriptionResponse.ok) {
          throw new Error(`HTTP error! status: ${subscriptionResponse.status}`);
        }

        const subscriptionData = await subscriptionResponse.json();
        setSubscriptionType(subscriptionData.status);
        const subscriptionEndDate = new Date(
          subscriptionData.current_period_end
        );
        setSubscriptionEndDate(
          subscriptionEndDate.toLocaleDateString().replace(/\//g, "-")
        );

        const API_ENDPOINT = `/api/users/${protectedData}/progress`;

        const response = await fetch(API_ENDPOINT, {
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        setProgressData(data);
      } catch (err) {
        setError(err.message);
        navigate("/login");
        return;
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [API_ENDPOINT]);

  if (loading) {
    return (
      <div className="progress-container">
        <div className="spinner"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="progress-container">
        <p>Error fetching progress data: {error}</p>
      </div>
    );
  }

  const {
    current_streak,
    max_streak,
    streak_improvement_percentage,
    total_tasks_solved,
    total_tasks_solved_percentage,
    daily_tasks_solved_last_7_days,
    tasks_solved_last_7_days_improvement_percentage,
    tasks_solved_by_topic,
    total_theories_solved,
    total_theories_solved_percentage,
    theories_solved_by_topic,
  } = progressData;

  const tasksSolvedLast7Days = daily_tasks_solved_last_7_days;

  const theoriesSolvedArray = Object.entries(theories_solved_by_topic).map(
    ([name, solved]) => ({
      name: name.charAt(0).toUpperCase() + name.slice(1),
      solved,
    })
  );

  return (
    <div className="progress-container">
      {showInfoModal && (
        <SubscribeInfoModal
          onClose={closeInfoModal}
          subscriptionType={subscriptionType}
          text={infoText || undefined}
        />
      )}
      {showPaymentModal && (
        <PaymentModal
          onClose={closePaymentModal}
          subscriptionType={subscriptionType}
          subscriptionEndDate={subscriptionEndDate}
          user_id={user_id}
        />
      )}
      <LeftSidebar
      />
      <div className="progress-main">
        <h1 className="progress-title">Твой прогресс</h1>
        <div className="progress-layout">
          <div className="left-side">
            <Streak
              currentStreak={current_streak}
              streakImprovementPercentage={streak_improvement_percentage}
              maxStreak={max_streak}
            />
            <TasksCompleted
              tasksCompleted={total_tasks_solved}
              completionPercentage={total_tasks_solved_percentage}
            />
          </div>
          <div className="right-side">
            <TasksOverTime
              dailyTasksSolvedLast7Days={tasksSolvedLast7Days}
              percentageChange={tasks_solved_last_7_days_improvement_percentage}
            />
            {/* <TopicsCompleted
              totalTheoriesSolved={total_theories_solved}
              totalTheoriesSolvedPercentage={total_theories_solved_percentage}
              theoriesSolvedByTopic={theoriesSolvedArray}
            />
            <PaiTasks tasksSolvedByTopic={tasks_solved_by_topic} /> */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Progress;
